import React from 'react';

type ReferralInviteBannerProps = {
    message: string;
};

/** Slim invite banner above quiz hero / email capture. */
const ReferralInviteBanner: React.FC<ReferralInviteBannerProps> = ({ message }) => (
    <div
        className="w-full rounded-xl px-3 py-2.5 mb-4 text-center"
        style={{
            backgroundColor: '#E6FFFA',
            border: '1px solid #38B2AC',
        }}
        role="status"
    >
        <p className="font-poppins text-[13px] leading-[1.4] font-semibold text-[#234E52]">
            {message}
        </p>
    </div>
);

export default ReferralInviteBanner;
